module.exports = __webpack_public_path__ + "static/AngelaHe13-e12bd356281086d6cda5bb902b915b7f.png";